import type { FilterOption } from '@models/Filter'
import type { Projectbetrokkene } from '@models/Projectbetrokkene'

export {
  isProjectbetrokkeneWijzigbaar,
  gebiedenVanVerantwoordelijke,
  groupProjectbetrokkenenByVerantwoordelijkeAndGebied,
  sortProjectbetrokkenenByType,
}

/** Requirements for changing projectbetrokkenen of Aanvraag are still unclear, so for now only Hoofdleiding is editable */
const WIJZIGBARE_PROJECT_TYPES: Projectbetrokkene['projectType'][] = [
  'Hoofdleiding',
]

const isProjectbetrokkeneWijzigbaar = (
  projectType: Projectbetrokkene['projectType'],
) => WIJZIGBARE_PROJECT_TYPES.includes(projectType)

/**
 * De gebieden waarin de verantwoordelijke zelf is opgevoerd; alleen daar kan
 * een verantwoordelijkheidscontext bestaan.
 */
const gebiedenVanVerantwoordelijke = (
  projectbetrokkenen: Projectbetrokkene[],
): FilterOption[] =>
  projectbetrokkenen
    .filter(
      ({ organisatie, verantwoordelijke }) => organisatie === verantwoordelijke,
    )
    .reduce(
      (gebieden, { gebiedscode, gebiedscodeLabel }) =>
        gebieden.some(({ code }) => code === gebiedscode)
          ? gebieden
          : [...gebieden, { code: gebiedscode, label: gebiedscodeLabel }],
      [] as FilterOption[],
    )
    .sort((a, b) => a.label.localeCompare(b.label))

const groupProjectbetrokkenenByVerantwoordelijkeAndGebied = (
  projectbetrokkenen: Projectbetrokkene[],
) => {
  return projectbetrokkenen
    .sort((a, b) => a.gebiedscodeLabel.localeCompare(b.gebiedscodeLabel))
    .reduce(
      (acc, projectbetrokkene) => {
        const key =
          projectbetrokkene.verantwoordelijke +
          ' - ' +
          projectbetrokkene.gebiedscode

        if (!acc[key]) {
          acc[key] = []
        }

        acc[key].push(projectbetrokkene)
        acc[key] = sortProjectbetrokkenenByType(acc[key])

        return acc
      },
      {} as Record<string, Projectbetrokkene[]>,
    )
}

const sortProjectbetrokkenenByType = (
  projectbetrokkenen: Projectbetrokkene[],
): Projectbetrokkene[] => {
  return [...projectbetrokkenen].sort((a, b) => a.type.localeCompare(b.type))
}
